import {
  DndContext,
  DndContextProps,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

export function Context(props: DndContextProps) {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    }),
  );

  return <DndContext sensors={sensors} {...props} />;
}
